import http from "@/http-common";

/* eslint-disable */
class CustomerService {

    getCustomerDetail(id): Promise<any> {
      return http.get("/customer/" + id + "/profile");
    }

    editCustomer(id,data): Promise<any> {
      return http.put("/customer/" + id + "/profile/edit", data);
    }

    customerChangePassword(id,data): Promise<any> {
      return http.post("/customer/" + id + "/profile/change-password", data);
    }

}
  
export default new CustomerService();
